import React, { Component } from 'react'
import './App.css'
import Moldura from './components/moldura.js'
import { loadReCaptcha } from 'react-recaptcha-v3'

class App extends Component {

  constructor(props) {
    super(props);

    let urlsite = window.location.href;
    let servidor = ''

    if (urlsite.indexOf('teletoscana') > -1){
      servidor = 'toscana'
    }else if (urlsite.indexOf('crefisa') > -1){
      servidor = 'crefisa'
    }else if (urlsite.indexOf('panda') > -1) {
      servidor = 'panda'
    }else{
      servidor = 'adobe'
    }

    this.state = {
      stylePath: './css/'+servidor+'.css',
      servidor: servidor
    }
  }

  componentDidMount() {
    //loadReCaptcha('6LfeNKsUAAAAANSlpAAxKqGFNttkZ1XBcQVR1Nuw');
  }

  render() {
    return (
      <div>
        <link rel="stylesheet" type="text/css" href={this.state.stylePath} />
        <Moldura servidor={this.state.servidor} />
      </div>
    );
  }
}

export default App;
